<section class="checklist-register-page-container" *ngIf="!isLoadingLabels && !isLoadingForm">
	<header>
		<h1>{{ labels.lbl_checklist_criacao }}</h1>

		<div class="under-title">
			<nav class="navigation">
				<a [routerLink]="'/checklist'">< {{ labels['lbl_checklist'] }}</a>
				<a [routerLink]="'/checklist/new'">< {{ labels['lbl_geral_registrar'] }}</a>
			</nav>
		</div>
	</header>
	<main>
		<div class="folder-container">
			<div class="tabs-container">
				<div>
					<span class="tab" [ngClass]="{ selected: tabView === 'info' }" (click)="changeTab('info')">{{
						labels['lbl_geral_informacoes']
					}}</span>
				</div>
			</div>
			<div class="tab-content-container" *ngIf="tabView === 'info'">
				<div class="form-header first">
					<span>{{ labels['lbl_geral_informacoes_gerais'] }}</span>
				</div>
				<div class="form-body">
					<cpi-generic-form-gen
						[setGenericForm]="generalInformationForm"
						[columns]="1"
						[labels]="labels"
						[disabled]="viewType === 'read'"
						(tappedField)="generalFormToInterface($event)">
					</cpi-generic-form-gen>
				</div>
				<div class="form-header">
					<span>{{ labels['lbl_geral_procedimentos'] }}</span>
				</div>
				<div class="form-body" #procedureFormBody>
					<div
						class="wrap-card"
						[ngClass]="{ 'dragged-procedure': isDragging && draggingProcedureIndex == index }"
						*ngFor="let procedure of procedureForm; let index = index">
						<div class="button-container" *ngIf="viewType === 'edit'">
							<button (click)="removeStepFromProcedure(index)"><fa-icon [icon]="icons.faTimes"></fa-icon></button>
							<button
								(mousedown)="
									setDragButtonPosition(procedureFormBody, $event); isDragging = true; draggingProcedureIndex = index
								">
								<fa-icon [icon]="icons.faHand"></fa-icon>
							</button>
						</div>
						<cpi-generic-form-gen
							[setGenericForm]="procedure"
							[columns]="1"
							[labels]="labels"
							[disabled]="viewType === 'read'"
							(tappedField)="procedureFormToInterface($event, index)">
						</cpi-generic-form-gen>
						<!-- <div class="dragged-procedure" *ngIf="isDragging && draggingProcedureIndex == index"></div> -->
						<div
							class="drop-option"
							(mousemove)="setDragButtonPosition(procedureFormBody, $event)"
							(mouseenter)="dropOption.classList.add('hover')"
							(mouseleave)="dropOption.classList.remove('hover')"
							(mouseup)="
								moveStepFromProcedure(draggingProcedureIndex, index); isDragging = false; draggingProcedureIndex = null
							"
							*ngIf="isDragging"
							#dropOption></div>
					</div>
					<div class="button-container" *ngIf="viewType === 'edit'">
						<button (click)="addStepToProcedure()"><fa-icon [icon]="icons.faPlus"></fa-icon></button>
					</div>

					<div
						class="drag-screen"
						(mousemove)="setDragButtonPosition(procedureFormBody, $event)"
						(mouseup)="isDragging = false"
						*ngIf="isDragging"></div>
					<button
						class="isDraggingButton"
						[ngStyle]="{ 'left.px': dragButtonPosition.x, 'top.px': dragButtonPosition.y }"
						*ngIf="isDragging">
						<fa-icon [icon]="icons.faHand"></fa-icon>
					</button>
				</div>
				<div class="form-header last">
					<div class="button-container" *ngIf="viewType === 'read' && checklistRegister.status !== 'RUNNING'">
						<button (click)="viewType = 'edit'">{{ labels['lbl_geral_editar'] }}</button>
					</div>
					<div class="button-container" *ngIf="viewType === 'edit'">
						<button
							[ngClass]="{ disabled: isUpdatingChecklist }"
							(click)="createChecklist()"
							*ngIf="!checklistRegister.id || checklistRegister.id === ''">
							{{ labels['lbl_geral_registrar'] }}
							<cpi-dot-bounce-loading-effect
								[color]="'var(--const-white)'"
								*ngIf="isUpdatingChecklist"></cpi-dot-bounce-loading-effect>
						</button>
						<button
							[ngClass]="{ disabled: isUpdatingChecklist || isDeletingChecklist }"
							(click)="deleteChecklist()"
							*ngIf="checklistRegister.id && checklistRegister.id !== ''">
							{{ labels['lbl_geral_excluir'] }}
							<cpi-dot-bounce-loading-effect
								[color]="'var(--const-white)'"
								*ngIf="isDeletingChecklist"></cpi-dot-bounce-loading-effect>
						</button>
						<button
							[ngClass]="{ disabled: isUpdatingChecklist || isDeletingChecklist }"
							(click)="updateChecklist()"
							*ngIf="checklistRegister.id && checklistRegister.id !== ''">
							{{ labels['lbl_geral_atualizar'] }}
							<cpi-dot-bounce-loading-effect
								[color]="'var(--const-white)'"
								*ngIf="isUpdatingChecklist"></cpi-dot-bounce-loading-effect>
						</button>
					</div>
					<div class="button-container" *ngIf="checklistRegister.status === 'RUNNING'">
						<span>{{ labels['lbl_edicao_bloqueada_checklist_execucao'] }}</span>
					</div>
				</div>
			</div>
		</div>
	</main>
</section>
